/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.publicBanners.internal

import features.publicBanners.models.BannersModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class PublicBannersRequest : NetworkRequest() {

    suspend fun getPublicBanners(
        overrideHeaders: Map<String, String>? = null,

    ): IOResult<BannersModel> {
        return safeNetworkCall {
            get(
                endpoint = PublicBannersEndpoint,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
